<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>Order Summary By Code</h1>
                    <v-layout>

                        <v-flex xs2 mr-2>
                            <v-autocomplete :items="itemCustCode" ref="codeFrom" 
                            v-model="codeFrom" label="Code from:" @change="changeCodeTo"></v-autocomplete>
                        </v-flex>
                        <v-flex xs2 mr-2>
                            <v-autocomplete :items="itemCustCode" ref="codeTo"
                             v-model="codeTo" label="Code to:"></v-autocomplete>
                        </v-flex>

                        <!-- Start date -->
                        <v-flex xs2 mr-2>
                            <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                            offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="startDate" label="Start date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate" @input="menuStartDate = false"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <!-- End date -->
                        <v-flex xs2>
                            <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                            offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="endDate" label="End date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" @input="menuEndDate = false" :min ="startDate" :max="nowDate"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex>
                            <v-btn fab small @click="getSo" color="primary"><v-icon>search</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                    <br>

                    <!-- Order -->
                    <v-data-table :headers="headers" :items="detail" class="elevation-1" v-bind:pagination.sync="pagination">
                        <template v-slot:no-data>
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.code}}</td>
                            <td>{{props.item.name}}</td>
                            <td>{{props.item.orderDate.substr(0,10)}}</td>
                            <td>{{props.item.orderNo}}</td>
                            <td>{{props.item.poRef}}</td>
                            <td>{{props.item.invNo.toString()}}</td>
                            <td>{{props.item.invDate.toString()}}</td>
                            <td class="text-xs-right">{{props.item.net.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" @click="viewOrder(props.item)" v-on="on">visibility</v-icon>
                                    </template>
                                    <span>View order details</span>
                                </v-tooltip>
                            </td>
                        </template>
                        <template v-slot:footer>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><strong>Total:</strong></td>
                            <td class="text-xs-right"><strong>{{sumNet.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td></td>
                        </template>
                    </v-data-table>

                    <!-- View order -->
                    <v-dialog v-model="showViewOrder" max-width="1220px">
                        <v-card>
                            <v-card-title class="headline">
                                <v-flex xs2>
                                    View Order
                                </v-flex>
                                <v-flex text-xs-right>
                                    <v-icon @click="showViewOrder = false">clear</v-icon>
                                </v-flex>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-container>
                                    <!-- Order Form     -->
                                    <!-- Date selector -->
                                    <v-layout>
                                        <v-flex xs11 text-xs-right>Order no: </v-flex>
                                        <v-flex xs1 text-xs-right>
                                            <input type="text" class="line" v-model="orderNo" disabled>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs11 text-xs-right>Order date: </v-flex>
                                        <v-flex  xs1 text-xs-right>
                                            <input type="text" class="line" v-model="orderDate" disabled>
                                        </v-flex>
                                    </v-layout>

                                    <!-- customer info -->
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>Customer code:</v-flex>
                                        <v-flex xs6>
                                            <input type="text" class="inputCust" size="35" v-model="code" disabled>
                                        </v-flex>
                                    </v-layout>    
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>Customer name:</v-flex>
                                        <v-flex xs6>
                                            <input type="text" class="inputCust" size="35" v-model="name" disabled>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>Address:</v-flex>
                                        <v-flex xs8>
                                            <input type="text" class="inputCust" size="65" v-model="address" disabled>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>PO ref#:</v-flex>
                                        <v-flex xs5>
                                            <input type="text" class="inputCust" size="30" v-model="poRef" disabled>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>Contact name:</v-flex>
                                        <v-flex xs5>
                                            <input type="text" class="inputCust" size="25" v-model="contact" disabled>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex xs2 text-xs-right my-1>Tel:</v-flex>
                                        <v-flex xs5>
                                            <input type="text" class="inputCust" v-model="tel" disabled>
                                        </v-flex>
                                    </v-layout>

                                    <!-- Order detail -->
                                    <br>
                                    <v-layout table>
                                        <v-flex xs1 text-xs-center><h4>No</h4></v-flex>
                                        <v-flex xs1><h4>Model</h4></v-flex>
                                        <v-flex xs3><h4>Description</h4></v-flex>
                                        <v-flex xs1 text-xs-center><h4>Frame</h4></v-flex>
                                        <v-flex xs1 text-xs-center><h4>Front</h4></v-flex>
                                        <v-flex xs1 text-xs-center><h4>Quantity</h4></v-flex>
                                        <v-flex xs2 text-xs-right><h4>Price</h4></v-flex>
                                        <v-flex xs2 text-xs-right><h4>Amount</h4></v-flex>
                                    </v-layout>
                                    <v-layout v-for="(item,i) in orderDetails" :key="i" collapse tableDetail>
                                        <v-flex xs1 text-xs-center>
                                            <font size=2>{{i+1}}</font>
                                        </v-flex>
                                        <v-flex xs1>
                                            <font size=2>{{item.Code}}</font>
                                        </v-flex>
                                        <v-flex xs3>
                                            <font size=2>{{item.NameThai}}</font>
                                        </v-flex>
                                        <v-flex xs1 text-xs-center>
                                            <font size=2>{{item.frame}}</font>
                                        </v-flex>
                                        <v-flex xs1 text-xs-center>
                                            <font size=2>{{item.front}}</font>
                                        </v-flex>
                                        <v-flex xs1 text-xs-center>
                                            <font size=2>{{item.num}}</font>
                                        </v-flex>
                                        <v-flex xs2>
                                            <vue-numeric separator="," :precision="2" disabled :value="item.PriceMM" class="numeric"></vue-numeric>
                                        </v-flex>
                                        <v-flex xs2>
                                            <vue-numeric separator="," :precision="2" disabled :value="item.amt" class="numeric"></vue-numeric>
                                        </v-flex>
                                    </v-layout>
                                    <br>
                                    <v-layout>
                                        <v-flex xs6>
                                            <v-layout>
                                                <v-flex>
                                                    <strong>Shipping Address: </strong>
                                                    <textarea rows="4" cols="50" class="lineShipAdd" v-model="shipAdd" disabled></textarea>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex>
                                                    <strong>Shipping Date: </strong>
                                                    <input class="lineDate" v-model="shipDate" size="10" disabled>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex>
                                                    <strong>Remark: </strong>
                                                    <textarea rows="2" cols="50" class="lineShipAdd" v-model="remark" disabled></textarea>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-layout>
                                                <v-flex xs10 text-xs-right><font size=2>Total:</font></v-flex>
                                                <v-flex xs4 line>
                                                    <vue-numeric separator="," :precision="2" disabled :value="sumTotal" class="numericNet"></vue-numeric>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs10 text-xs-right><font size=2>Discount:</font></v-flex>
                                                <v-flex xs4 line>
                                                    <vue-numeric separator="," :precision="2" disabled v-model="disc" class="numericNet"></vue-numeric>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs10 text-xs-right><font size=2>Net amount:</font></v-flex>
                                                <v-flex xs4 line>
                                                    <vue-numeric separator="," :precision="2" disabled :value="sumTotal - disc" class="numericNet"></vue-numeric>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout border v-for="(item,i) in countPayment" :key="item.i">
                                        <v-layout justify-center>
                                                <v-flex xs3 mr-3>
                                                    <strong>Payment method {{i+1}}: </strong>
                                                    <input class="lineShipAdd" v-model="item.payMent" size="30" disabled>
                                                </v-flex>
                                                <v-flex xs4 ml-5>
                                                    <strong>Down payment {{i+1}}: </strong>
                                                    <vue-numeric separator="," :precision="2" disabled :value="item.down" class="down"></vue-numeric>
                                                </v-flex>
                                                <v-flex xs2 ml-3>
                                                    <strong>Payment date {{i+1}}: </strong>
                                                    <input class="lineShipAdd" v-model="item.date" size="10" disabled>
                                                </v-flex>
                                        </v-layout>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
import VueNumeric from 'vue-numeric'
export default {
    components:{
        mainMenu,
        VueNumeric
    },
    data(){
        return{
            itemCustCode: [],
            codeFrom: '',
            codeTo: '',
            nowDate: new Date().toISOString().substr(0,10),
            menuStartDate: false,
            startDate: new Date().toISOString().substr(0,10),
            menuEndDate: false,
            endDate: new Date().toISOString().substr(0,10),

            headers:[
                { text: 'Customer id', value: 'code', align: 'left' },
                { text: 'Customer name', sortable: false, align: 'left' },
                { text: 'Date', align: 'left', value: 'orderDate' },
                { text: 'Order no', sortable: false, align: 'left' },
                { text: 'PO Ref', sortable: false, align: 'left' },
                { text: 'Invoice no', sortable: false, align: 'left' },
                { text: 'Invoice date', sortable: false, align: 'left' },
                { text: 'Net amount', sortable: false, align: 'right' },
                { text: '', sortable: false, align: 'left' },
            ],
            pagination: {'sortBy': 'orderDate', 'descending': false},
            detail: [],

            showViewOrder: false,
            orderNo: '',
            orderDate: '',
            code: '',
            name: '',
            address: '',
            district: '',
            poRef: '',
            contact: '',
            tel: '',
            shipAdd: '',
            shipDate: '',
            remark: '',
            orderDetails: [],
            disc: 0,
            net: 0,
            countPayment: [],
        }
    },
    methods:{
        getCustomerCode(){
            db.collection("customer").get()
            .then(query=>{
                this.itemCustCode = []
                let result = []
                let customer = []
                query.forEach(doc=>{
                    result.push(doc.data())
                })
                sessionStorage.customer = JSON.stringify(result)
                customer = JSON.parse(sessionStorage.customer)
                customer.forEach(rec=>{
                    this.itemCustCode.push(rec.code)
                })
                this.itemCustCode.sort()
            })
        },

        changeCodeTo(){
            this.codeTo = this.codeFrom
        },

        getSo(){
            let app = this
            if(!this.codeFrom || !this.codeTo){
                if(!this.codeFrom){
                    alert("Please input code from.")
                    this.$nextTick(()=>this.$refs.codeFrom.focus())
                }
                else{
                    alert("Please input code to.")
                    this.$nextTick(()=>this.$refs.codeTo.focus())
                }
            }
            else{
                this.detail = []
                db.collection("order").where("orderDate", ">=", this.startDate).where("orderDate", "<=", this.endDate).get()
                .then(query=>{
                    let res = []
                    query.forEach(doc=>{
                        res.push({ ...doc.data(), invNo: [], invDate: [] })
                    })
                    let doc = res.filter(rec=>rec.code >= this.codeFrom && rec.code <= this.codeTo && rec.status != "Cancelled")
                    let i = 0
                    doc.forEach(rec=>{
                        db.collection("invoice").where("orderNo", "==", rec.orderNo).get()
                        .then(ref=>{
                            ref.forEach(inv=>{
                                rec.invNo.push(inv.data().invNo)
                                rec.invDate.push(inv.data().invDate.substr(0,10))
                            })
                            i++
                            callback()
                        })
                    })
                    let callback = function
                    callback(){
                        if(doc.length === i){
                            app.detail = doc
                            if(app.detail.length == 0){
                                alert("Data not found.")
                            }
                        }
                    }
                })
            }
        },

        viewOrder(item){
            db.collection("order").where("orderNo", "==", item.orderNo).get()
            .then(querySnapshot=> {
                if(querySnapshot.empty){
                    alert("Order No is not correct...\nPlease Try again")
                    this.$refs.orderNo.focus()
                }else{
                    this.showViewOrder = true
                    let doc = querySnapshot.docs[0].data()
                    let docId = querySnapshot.docs[0].id

                    this.orderId = docId
                    this.orderNo = doc.orderNo
                    this.orderDate = doc.orderDate.substr(0,10)
                    this.code = doc.code
                    this.name = doc.name
                    this.address = doc.address
                    this.poRef = doc.poRef
                    this.contact = doc.contact
                    this.tel = doc.tel
                    this.orderDetails = doc.detail
                    this.shipAdd = doc.shipAdd
                    this.shipDate = doc.shipDate
                    this.district = doc.district
                    this.countPayment = doc.countPayment
                    this.disc = doc.disc
                    this.remark = doc.remark
                }
            })
        },
    },
    computed:{
        sumNet(){
            return this.detail.reduce((total,item)=>total+(item.net),0)
        },

        // Calculate total
        sumTotal(){
            return this.orderDetails.reduce((total,item) => total+(item.amt),0)
        },
    },
    mounted(){
        if(!sessionStorage.customer){
            this.getCustomerCode()
        }
        else{
            let customer = []
            customer = JSON.parse(sessionStorage.customer)
            customer.forEach(rec=>{
                this.itemCustCode.push(rec.code)
            })
            this.itemCustCode.sort()
        }
    }
}
</script>
<style scoped>
.down{
    text-align: right;
    width: 100%;
    border-bottom: 1px solid black;
}
.border{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    padding: 0.5%;
}
.line{
    border-bottom: 1px solid black;
    text-align: right;
    width: 100%;
}
.lineShipAdd{
    border-bottom: 1px solid black;
    /* text-align: right; */
    width: 100%;
}
.lineDate{
    border-bottom: 1px solid black;
}
.inputCust{
  /* width: 30%; */
  height: 30px;
  padding: 13px 10px;
  display: inline-block;
  /* border: 1px solid #ccc; */
  /* border-radius: 4px; */
  /* box-sizing: border-box; */
  border-bottom: 1px solid black;
}
.table{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.collapse:nth-child(even){
    background-color: #dddddd;
}
.tableDetail{
    /* border-top: 1px solid black; */
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.numeric{
    text-align: right;
    width: 100%;
}
.numericNet{
    text-align: right;
    width: 100%;
    font-weight:bold;
}
</style>